import { Trans } from "app/utils";
import React from "react";

interface DisclaimerProps {
    organizationName: string;
  }

const DisclaimerText: React.FC<DisclaimerProps> = ({ organizationName }) => {
  switch (organizationName.toLowerCase()) {
    case "rtx":
      return (
        <Trans>
          US and Non-US Persons Technical Data/Information
          Strictly Prohibited US and Non-US Persons
        </Trans>
      );
    case "synopsys":
      return (
        <Trans>
          Your stories will help us showcase the great culture at Synopsys
          to both current and potential future employees!
        </Trans>
      );
    case "premise health":
      return (
        <>
          <Trans>Before submitting your story, please review

          </Trans> Premise Health&#39;s{" "}
          <a target="_blank" rel="noopener noreferrer" href="https://culturehq-assets.s3.us-west-2.amazonaws.com/pdf/IRC+Social+Media+Policy.pdf">
            <Trans>Social Media Policy.</Trans>
          </a>
        </>
      );
    default:
      return <></>;
  }
};

export default DisclaimerText;
